import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import { env } from '~/commons/config';
import PageNotFound from '~/commons/components/PageNotFound.jsx';

import {
  Nav,
} from './layout';
import {
  RouteArticles,
  RouteSite,
  RouteAnnouncements,
  RouteCompetitions,
  RouteSchools,
  RouteReports,
  RouteUsers,
  RouteDashboards,
  RouteThemeReports,
} from './routes';

const Admin = () => (
  <div className="container-fluid h-100 bg-lighter">
    <div className="row h-100">
      <Router basename={env.base}>
        <Nav />
        {/* normalize roles */}
        {/* eslint-disable-next-line no-unused-vars */}
        {null}
        <div className="col">
          <div className="px-4">
            <Switch>
              <Route path="/admin" exact>
                {(() => {
                  const roles = (env.user && env.user.roles) || [];
                  const isSysAdmin = roles.includes('admin');
                  const isSchoolOrTeacher = roles.includes('schoolAdmin') || roles.includes('teacher');
                  let dest = '/admin/dashboard';

                  if (isSysAdmin) dest = '/admin/users/students';
                  else if (isSchoolOrTeacher) dest = '/admin/management';

                  return <Redirect to={dest} />;
                })()}
              </Route>
              <Route path="/admin/dashboard">
                <RouteDashboards />
              </Route>
              <Route path="/admin/management">
                <RouteDashboards />
              </Route>
              <Route path="/admin/users">
                <RouteUsers />
              </Route>
              <Route path="/admin/schools">
                <RouteSchools />
              </Route>
              <Route path="/admin/articles">
                <RouteArticles />
              </Route>
              <Route path="/admin/competitions">
                <RouteCompetitions />
              </Route>
              <Route path="/admin/site">
                <RouteSite />
              </Route>
              <Route path="/admin/announcements">
                <RouteAnnouncements />
              </Route>
              <Route path="/admin/reports">
                <RouteReports />
              </Route>
              <Route path="/admin/themeReports">
                <RouteThemeReports />
              </Route>
              <Route path="*">
                <PageNotFound vAlign />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    </div>
  </div>
);

export default Admin;
